/**
 * Retries a promise-returning function up to `retries` times
 * with `delay` ms between attempts.
 */
const withRetry = (fn, retries = 2, delay = 1000) =>
  fn().catch(err =>
    retries > 0
      ? new Promise(resolve => setTimeout(resolve, delay)).then(() => withRetry(fn, retries - 1, delay))
      : Promise.reject(err)
  );

export default withRetry;
